import type * as core from '../../../../../../../core'

export const query: core.mosaic.Widget.Query = {
  selection: {
    '{}': {
      name: 'Area of Concern by Functional Area',
      type: 'charts',
      content: {
        '{}': {
          data: {
            '[]': [
              {
                '{}': {
                  name: 'Area of Concern',
                  values: {
                    '[]': [
                      {
                        '{}': {
                          name: 'Change Impacts',
                          points: {
                            '[]': [
                              {
                                '{}': {
                                  x: 'Build / Functional',
                                  y: {
                                    '#': {
                                      '@': 'buildFunctional',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Change Management',
                                  y: {
                                    '#': {
                                      '@': 'changeManagement',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Data Integration',
                                  y: {
                                    '#': {
                                      '@': 'dataIntegration',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Data Migration',
                                  y: {
                                    '#': {
                                      '@': 'dataMigration',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Marketing Cloud',
                                  y: {
                                    '#': {
                                      '@': 'marketingCloud',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Project Management',
                                  y: {
                                    '#': {
                                      '@': 'projectManagement',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Reporting & Analytics',
                                  y: {
                                    '#': {
                                      '@': 'reportingAndAnalytics',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Technical',
                                  y: {
                                    '#': {
                                      '@': 'technical',
                                    },
                                  },
                                },
                              },
                            ],
                          },
                        },
                      },
                    ],
                  },
                  xLabel: 'Functional Area',
                  yLabel: 'Count',
                },
              },
            ],
          },
          type: 'bar',
        },
      },
    },
  },
  subqueries: {
    technical: {
      filter: {
        and: [
          {
            '=': [
              {
                '@.': '!functional_area',
              },
              'Technical',
            ],
          },
          {
            '=': [
              {
                '@.': '!area_of_concern',
              },
              true,
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    dataMigration: {
      filter: {
        and: [
          {
            '=': [
              {
                '@.': '!functional_area',
              },
              'Data Migration',
            ],
          },
          {
            '=': [
              {
                '@.': '!area_of_concern',
              },
              true,
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    marketingCloud: {
      filter: {
        and: [
          {
            '=': [
              {
                '@.': '!functional_area',
              },
              'Marketing Cloud',
            ],
          },
          {
            '=': [
              {
                '@.': '!area_of_concern',
              },
              true,
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    buildFunctional: {
      filter: {
        and: [
          {
            '=': [
              {
                '@.': '!functional_area',
              },
              'Build / Functional',
            ],
          },
          {
            '=': [
              {
                '@.': '!area_of_concern',
              },
              true,
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    dataIntegration: {
      filter: {
        and: [
          {
            '=': [
              {
                '@.': '!functional_area',
              },
              'Data Integration',
            ],
          },
          {
            '=': [
              {
                '@.': '!area_of_concern',
              },
              true,
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    changeManagement: {
      filter: {
        and: [
          {
            '=': [
              {
                '@.': '!functional_area',
              },
              'Change Management',
            ],
          },
          {
            '=': [
              {
                '@.': '!area_of_concern',
              },
              true,
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    projectManagement: {
      filter: {
        and: [
          {
            '=': [
              {
                '@.': '!functional_area',
              },
              'Project Management',
            ],
          },
          {
            '=': [
              {
                '@.': '!area_of_concern',
              },
              true,
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    reportingAndAnalytics: {
      filter: {
        and: [
          {
            '=': [
              {
                '@.': '!functional_area',
              },
              'Reporting & Analytics',
            ],
          },
          {
            '=': [
              {
                '@.': '!area_of_concern',
              },
              true,
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
  },
}
